export default [
  {
    typ: "deckungssumme-hg",
    titel: "",
    produktLinien: ["002", "003"],
    selectname: "deckungssumme",
    selectoptionen: [
      { label: "10 Mio. €", value: 100 },
      { label: "15 Mio. €", value: 150 },
      { label: "25 Mio. €", value: 250 },
      { label: "50 Mio. €", value: 500 },
    ],
  },
];
